import {Activity, ActivityType} from '../activity';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class RequestApprovalActivity extends Activity {
  public ActivityExecutionCondition: string;
  public ApprovalCompleteEmailTemplate: string;
  public ApprovalDeniedEmailTemplate: string;
  public ApprovalEmailTemplate: string;
  public ApprovalTimeoutEmailTemplate: string;
  public Approvers: string;
  public Duration: string;
  private _Escalation: string;
  public EscalationEmailTemplate: string;
  public Threshold: string;

  get Escalation(): string {
    return this._Escalation;
  }

  set Escalation(value: string) {
    this._Escalation = value == null || value.length === 0 ? value : value.trim();
  }

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.RequestApproval);
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['ApprovalCompleteEmailTemplate'] = ActivityPropertyDataType.STRING;
    this._properties['ApprovalDeniedEmailTemplate'] = ActivityPropertyDataType.STRING;
    this._properties['ApprovalEmailTemplate'] = ActivityPropertyDataType.STRING;
    this._properties['ApprovalTimeoutEmailTemplate'] = ActivityPropertyDataType.STRING;
    this._properties['Approvers'] = ActivityPropertyDataType.STRING;
    this._properties['Duration'] = ActivityPropertyDataType.STRING;
    this._properties['Escalation'] = ActivityPropertyDataType.STRING;
    this._properties['EscalationEmailTemplate'] = ActivityPropertyDataType.STRING;
    this._properties['Threshold'] = ActivityPropertyDataType.STRING;
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();

    if (this._Escalation == null || this._Escalation.length === 0) {
      this.EscalationEmailTemplate = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('request-approval', this.dialogConfig);
  }
}
